// extracted by mini-css-extract-plugin
export default {"searchWrapper":"styles_searchWrapper__zv9Zk","searchInput":"styles_searchInput__0IcAx"};